import type { FaireProductEntity } from "../../entity_types/product";

export const p_298fp5n577: FaireProductEntity = {
  token: "p_298fp5n577",
  type: "product",
  name: "Viral Triangle Cheese Squishy Toy",
  brandToken: "b_bya786doke",
  brandName: "Love and Repeat",
  imageUrl:
    "https://cdn.faire.com/fastly/484f8f527e95dc8378e000434e7eab4722460b0fce9fc7e9c602ebe2a8a35621.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/243d290c0bc3bc2759d45f6314e3f34ed73546aa3977bcb56f9bf5b772657c75.jpeg",
    "https://cdn.faire.com/fastly/e6c8af76d26d4ea069de895d61853868f55cb1d394c622b6f3d342ceadd88612.jpeg",
    "https://cdn.faire.com/fastly/44df87ca4ceba1ba7cf8f0fe9975cfd2d3ecad9f879a94f2baf4f94198583773.jpeg",
    "https://cdn.faire.com/fastly/f4d6224b227923eefd37bc42e7edd6fbc90022d836586fdc4e26100d92ca7d00.jpeg",
    "https://cdn.faire.com/fastly/453ba33a569aadfa51c14f5f997140e9449913e546b261c4c206389c274f58f2.jpeg",
    "https://cdn.faire.com/fastly/c0b2c3bc5bb6efad1e2c7d84e15cc4e2a02ee181609b247d56a62a619996a84c.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Viral Triangle Cheese Squishy Toy\n\n-Cheese Squishy Slow Rising Squeeze Toy, Soft Squishy Fidget Toy, Stress Relief Sensory Novelty Fidget Squishy Toy Gift for Kids and Adults\nRealistic Cheese Design and Fun Squeeze\n\n",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:45.458Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
